export const beefData = [
    {
        performanceProgress: 'ปริมาณขาย',
        quantity: 'ตัน',
        January: '13,483',
        February: '12,420',
        March: '11,888',
        April: '12,694',
        May: '10,255',
        June: '11,418',
        July: '10,406',
        August: '11,882',
        September: '10,298',
        October: '10,650',
        November: '13,002',
        December: '10,211',
        total: '138,607',
    },
    {
        performanceProgress: 'มูลค่าขาย',
        quantity: 'ล้านบาท',
        January: '147',
        February: '137',
        March: '134',
        April: '145',
        May: '119',
        June: '133',
        July: '124',
        August: '141',
        September: '125',
        October: '129',
        November: '159',
        December: '127',
        total: '1,622',
    },
    {
        performanceProgress: 'ราคาขาย',
        quantity: 'บาท/ก.ก.',
        January: '10.9',
        February: '11.0',
        March: '11.3',
        April: '11.4',
        May: '11.6',
        June: '11.7',
        July: '11.9',
        August: '11.9',
        September: '12.1',
        October: '12.1',
        November: '12.2',
        December: '12.5',
        total: '11.7',
    },
    {
        performanceProgress: 'ต้นทุนรวม',
        quantity: 'บาท/ก.ก.',
        January: '(10.4)',
        February: '(10.7)',
        March: '(10.7)',
        April: '(10.7)',
        May: '(11.3)',
        June: '(11.4)',
        July: '(11.6)',
        August: '(11.4)',
        September: '(11.7)',
        October: '(11.7)',
        November: '(11.7)',
        December: '(12.7)',
        total: '(11.3)',
    },
    {
        performanceProgress: 'กำไรสุทธิ',
        quantity: 'บาท/ก.ก.',
        January: '0.5',
        February: '0.3',
        March: '0.6',
        April: '0.7',
        May: '0.3',
        June: '0.3',
        July: '0.3',
        August: '0.5',
        September: '0.4',
        October: '0.4',
        November: '0.5',
        December: '(0.3)',
        total: '0.4',
    },
    {
        performanceProgress: '',
        quantity: 'ล้านบาท',
        January: '7',
        February: '4',
        March: '7',
        April: '9',
        May: '4',
        June: '3',
        July: '3',
        August: '6',
        September: '5',
        October: '4',
        November: '7',
        December: '(3))',
        total: '56',
    },
    {
        performanceProgress: '',
        quantity: '%',
        January: '5.0%',
        February: '2.8%',
        March: '5.3%',
        April: '6.0%',
        May: '2.9%',
        June: '2.4%',
        July: '2.7%',
        August: '4.3%',
        September: '3.6%',
        October: '2.9%',
        November: '4.3%',
        December: '(2.2)%',
        total: '3.4%',
    },
]